var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUploadImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6429 5.55558C12.2944 5.55558 12.0082 5.29646 12.0082 4.9772C12.0082 4.65793 12.2868 4.39881 12.6353 4.39881H12.6429C12.9914 4.39881 13.2742 4.65793 13.2742 4.9772C13.2742 5.29646 12.9914 5.55558 12.6429 5.55558ZM8.50042 10.6793C6.69225 10.6793 5.22163 9.33128 5.22163 7.67478C5.22163 6.01906 6.69225 4.67181 8.50042 4.67181C10.3086 4.67181 11.7792 6.01906 11.7792 7.67478C11.7792 9.33128 10.3086 10.6793 8.50042 10.6793ZM13.2305 2.37524C13.0882 2.33436 12.8811 2.24876 12.7069 2.0737C12.6345 2.00121 12.5368 1.81999 12.4425 1.6457C12.1883 1.17451 11.8407 0.529802 11.1411 0.259889C10.2421 -0.0855997 6.79074 -0.087142 5.86224 0.258347C5.17196 0.518234 4.82009 1.16603 4.56335 1.63876C4.46654 1.81613 4.36721 1.99967 4.29313 2.0737C4.11972 2.24953 3.91264 2.33436 3.78384 2.37215C1.00844 3.07547 0.5 4.72811 0.5 7.72799C0.5 12.0651 1.65494 14 8.50042 14C15.3451 14 16.5 12.0651 16.5 7.72799C16.5 4.72811 15.9924 3.07547 13.2305 2.37524Z",
    fill: "#009B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50053 5.82819C7.38852 5.82819 6.48443 6.65644 6.48443 7.67516C6.48443 8.69389 7.38852 9.52214 8.50053 9.52214C9.61254 9.52214 10.5166 8.69389 10.5166 7.67516C10.5166 6.65644 9.61254 5.82819 8.50053 5.82819Z",
    fill: "#009B4B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadImg);
export default __webpack_public_path__ + "static/media/icon_upload_img.173aaba9217fd800e18e05846cbfa7a4.svg";
export { ForwardRef as ReactComponent };